import FormSearch from './FormSearch.jsx';
import Input from './Input.jsx';

export {
  FormSearch,
  Input
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/list-handle-letters-search/index.js